// map carriers to appropriate display name

export const SHIPPING_CARRIERS = {
  ups: {
    value: 'ups',
    displayName: 'ups',
  },
  dhl_express: {
    value: 'dhl_express',
    displayName: 'dhl',
  },
};
